function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from "axios";
export default {
  props: {
    pageId: String,
    limit: Number
  },
  data: function data() {
    return {
      query: "",
      url: "//".concat(location.host, "/").concat(this.pageId, "/json/category-list.json"),
      title: "お知らせ",
      setdata: {
        count: null
      }
    };
  },
  mounted: function mounted() {
    this.query = this.setQuery();
    this.loadData();
  },
  methods: {
    setTopics: function setTopics(topics) {
      if (topics) return "topics=1";
    },
    setCount: function setCount(payload) {
      // console.log(payload);
      this.$set(this.setdata, 'count', Number(payload.detail[0]));
    },
    setQuery: function setQuery() {
      if (window.location.search === "" || window.location.search === void 0 || window.location.search == null) return {
        page: 1
      };
      var variables = window.location.search.split("?")[1].split("&"),
          obj = {};
      variables.forEach(function (v, i) {
        var variable = v.split("=");
        obj[variable[0]] = variable[1];
      });
      return obj;
    },
    setPageTitle: function setPageTitle(data) {
      var _this = this;

      var result = this.title;
      if (data === "" || data === void 0 || data == null) return result;
      if (this.query.topics) result = "トピックス";
      data.map(function (val, index, array) {
        if (String(val.basename) === String(_this.query.category)) {
          result = val.label;
          if (_this.query.topics) result += "のトピックス";
        }
      });
      return result;
    },
    loadData: function () {
      var _loadData = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios.get(this.url).then(function (res) {
                  _this2.title = _this2.setPageTitle(res.data);
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                // alert("データの取得に失敗しました、リロードしてください。");
                alert(_context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function loadData() {
        return _loadData.apply(this, arguments);
      }

      return loadData;
    }()
  }
};